"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSourceStatus = void 0;
var DataSourceStatus;
(function (DataSourceStatus) {
    DataSourceStatus["PUBLISHED"] = "PUBLISHED";
    DataSourceStatus["UNPUBLISHED"] = "UNPUBLISHED";
})(DataSourceStatus = exports.DataSourceStatus || (exports.DataSourceStatus = {}));
//# sourceMappingURL=dataSourceStatus.js.map